import React from 'react';
import {connect} from 'react-redux';
import {Card, Button, Modal, Tooltip, TreeSelect} from 'antd';
import PropTypes from 'prop-types';
import Chip from 'components/common/Chip';
import MaterialIcon from 'components/common/MaterialIcon';
import Avatar from 'components/common/Avatar';
import Spin from 'components/common/Spin';
import FChart from 'routes/Home/Basic/OrganizationChart/FChart';
import {indexPositions, emptyPositions} from 'routes/Home/Basic/OrganizationChart/Module';


@connect((state) => ({
  positions: state.Basic.OrganizationChart.positions,
}), {
  indexPositions,
  emptyPositions,
}, null, {withRef: true})
@autobind
/**
 *
 */
export default class ApplicantsTree extends React.PureComponent {
  static propTypes = {
    positions: PropTypes.arrayOf(PropTypes.object),
    indexPositions: PropTypes.func,
    selected: PropTypes.array,
    title: PropTypes.any,
    componentName: PropTypes.string,
    onChange: PropTypes.func,
    positionValue: PropTypes.arrayOf(PropTypes.object), // Add positionValue prop type
  };

  static defaultProps = {
    selected: [],
    componentName: 'Chart',
    onChange: () => {
    },
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      spinning: false,
      showAddForm: false,
      selected: props.selected,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {indexPositions, componentName, positions, positionValue} = this.props;
    
    // Process positionValue if it exists to initialize selected state
    if (positionValue && Array.isArray(positionValue)) {
      const positionIds = positionValue.map(item => `${item.id}`);
      this.setState({selected: positionIds});
    }
    
    if (!positions || app._.isEmpty(positions)) {
      this.setState({spinning: true}, () => {
        indexPositions(componentName, () => {
          this.setState({spinning: false});
        });
      });
    } else {
      this.setState({spinning: false});
    }
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    // Handle changes to the selected prop
    if (!app._.isEqual(this.props.selected, np.selected)) {
      this.setState({selected: np.selected});
    }
    
    // Handle changes to positionValue prop
    if (!app._.isEqual(this.props.positionValue, np.positionValue) && 
        np.positionValue && Array.isArray(np.positionValue)) {
      
      // Extract IDs from positionValue
      const positionIds = np.positionValue.map(item => `${item.id}`);
      
      // Update selected state with the new IDs
      this.setState({selected: positionIds});
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();

    app.dispatch(emptyPositions());
  }
  /**
   *
   * @return {Number[]}
   */
  selected() {
    // Make sure we return selected as an array of IDs (either strings or numbers)
    const { selected } = this.state;
    return Array.isArray(selected) ? selected : [];
  }

  test() {
    let items = [];
    for (let i = 0; i < 30; i++) {
      items.push({
        label: `Child Node5-${i}`,
        value: `0-1-2-${i}`,
        key: `0-1-2-${i}`,
      });
    }
    return items;
  }

  _treeData(positions, parent = null) {
    let items = [];
    if (positions) {
      positions.map((item) => {
        if (item.positionId == parent) {
          items.push({
            key: `treeSelect_Position_${item.id}`,
            value: `${item.id}`,
            label: `${item.name}${item.user && item.user.profile ? ` - ${item.user.profile.firstName} ${item.user.profile.lastName} (${item.user.profile.personnelId})` : ``}`,
            // Make posts selectable
            selectable: true,
            disabled: !!((item.user && item.user.active !== undefined && parseInt(item.user.active) == 0)),
            children: item.type == 'post' ? [] : this._treeData(positions, item.id),
          });
          if (item.type == 'post') {
            items.push(...this._treeData(positions, item.id));
          }
        }
      });
    }
    return items;
  }


  onChange = (selected) => {
    // Make sure selected is always an array
    const selectedArray = Array.isArray(selected) ? selected : [selected].filter(Boolean);
    
    this.setState({selected: selectedArray});
    console.log("New selection in ApplicantsTree:", selectedArray);
    
    // Pass the updated selection to the parent component
    this.props.onChange(selectedArray);
  };

  render() {
    const {positions, positionValue} = this.props;
    let treeData = this._treeData(positions, null);
    const SHOW_PARENT = TreeSelect.SHOW_PARENT;
    
    // If we have positionValue but no positions data in the tree
    if (positionValue && Array.isArray(positionValue) && 
        (!positions || positions.length === 0 || !treeData || treeData.length === 0)) {
      
      // Create tree data directly from the positionValue
      treeData = positionValue.map(item => ({
        key: `treeSelect_Position_${item.id}`,
        value: `${item.id}`,
        label: item.name,
        selectable: true
      }));
    }
    
    // Make sure selected values are strings to match the format in treeData
    const selectedValues = Array.isArray(this.state.selected) ? 
      this.state.selected.map(id => `${id}`) : [];
    
    console.log("Selected values:", selectedValues);
    console.log("Available tree data:", treeData);
    
    const tProps = {
      treeData,
      multiple: true,
      value: selectedValues,
      onChange: this.onChange,
      treeCheckable: true,
      showSearch: true,
      treeNodeFilterProp: 'label', // Change from 'title' to 'label' to match our data structure
      className: 'treeSelect',
      dropdownStyle: {maxHeight: 400, overflow: 'auto'},
      allowClear: true,
      treeDefaultExpandAll: false,
      showCheckedStrategy: SHOW_PARENT,
      searchPlaceholder: 'انتخاب کنید',
      style: {
        width: '100%',
        direction: 'rtl',
      },
    };
    return <TreeSelect {...tProps} />;
  }
}
